/* ==========================================================================
   ILAVIYA — cart page
   Quantity changes and removals go through /cart/change.js, then the section
   is re-rendered so totals, the shipping bar and the summary all stay true.
   ========================================================================== */
(function () {
  'use strict';

  var section = document.querySelector('[data-ilr-cart-section]');
  if (!section) return;

  var sectionId = section.getAttribute('data-ilr-cart-section');
  var busy = false;

  function setBusy(state) {
    busy = state;
    section.style.opacity = state ? '0.55' : '';
    section.style.pointerEvents = state ? 'none' : '';
  }

  function rerender() {
    return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sectionId))
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) throw new Error('no section html');
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-ilr-cart-shell]');
        var live = section.querySelector('[data-ilr-cart-shell]');
        if (!fresh || !live) throw new Error('shell missing');
        live.innerHTML = fresh.innerHTML;
        bind();
      });
  }

  function change(line, quantity) {
    if (busy) return;
    setBusy(true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (window.ILAVIYA) window.ILAVIYA.updateCartCount(cart.item_count);
        return rerender();
      })
      .catch(function () { window.location.reload(); })
      .then(function () { setBusy(false); });
  }

  function bind() {
    section.querySelectorAll('[data-ilr-cart-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = parseInt(btn.getAttribute('data-line'), 10);
        var step = parseInt(btn.getAttribute('data-ilr-cart-qty'), 10);
        var input = section.querySelector('[data-ilr-cart-input][data-line="' + line + '"]');
        if (!input) return;
        change(line, Math.max(0, (parseInt(input.value, 10) || 0) + step));
      });
    });

    section.querySelectorAll('[data-ilr-cart-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        change(parseInt(input.getAttribute('data-line'), 10), Math.max(0, parseInt(input.value, 10) || 0));
      });
    });

    section.querySelectorAll('[data-ilr-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        change(parseInt(btn.getAttribute('data-line'), 10), 0);
      });
    });

    // Clear Cart button
    var clearBtn = section.querySelector('[data-ilr-cart-clear]');
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        if (busy) return;
        setBusy(true);
        fetch('/cart/clear.js', {
          method: 'POST',
          headers: { Accept: 'application/json' }
        })
          .then(function () {
            if (window.ILAVIYA) window.ILAVIYA.updateCartCount(0);
            return rerender();
          })
          .catch(function () { window.location.reload(); })
          .then(function () { setBusy(false); });
      });
    }

    // Coupon logic
    initCoupons();
  }

  function initCoupons() {
    var couponInput = section.querySelector('#coupon-code-input');
    var applyBtn = section.querySelector('#apply-coupon-btn');
    var successBanner = section.querySelector('#coupon-success-banner');
    var successText = section.querySelector('#coupon-success-text');
    var removeBtn = section.querySelector('#remove-coupon-btn');
    
    var discountRow = section.querySelector('#cart-summary-discount-row');
    var discountLabel = section.querySelector('#cart-summary-discount-label');
    var discountVal = section.querySelector('#cart-summary-discount-value');
    var summaryTotal = section.querySelector('#cart-summary-total');

    if (!couponInput || !applyBtn || !successBanner || !summaryTotal) return;

    var originalTotalText = summaryTotal.getAttribute('data-original-total');
    if (!originalTotalText) {
      originalTotalText = summaryTotal.textContent;
      summaryTotal.setAttribute('data-original-total', originalTotalText);
    }
    var originalTotalVal = parseFloat(originalTotalText.replace(/[^\d.]/g, ''));

    // Check if there is a saved coupon
    var savedCoupon = sessionStorage.getItem('ilr-coupon');
    if (savedCoupon) {
      applyCoupon(savedCoupon);
    }

    applyBtn.addEventListener('click', function() {
      var code = (couponInput.value || '').trim().toUpperCase();
      if (code) {
        applyCoupon(code);
      }
    });

    couponInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        applyBtn.click();
      }
    });

    if (removeBtn) {
      removeBtn.addEventListener('click', function() {
        removeCoupon();
      });
    }

    section.querySelectorAll('[data-code]').forEach(function(offerBtn) {
      offerBtn.addEventListener('click', function() {
        var code = offerBtn.getAttribute('data-code');
        applyCoupon(code);
      });
    });

    function applyCoupon(code) {
      var discountAmount = 0;
      var label = '';

      if (code === 'WELCOME5') {
        discountAmount = Math.round(originalTotalVal * 0.05);
        label = 'Discount (WELCOME5)';
      } else if (code === 'FIRST150') {
        if (originalTotalVal > 1499) {
          discountAmount = 150;
          label = 'Discount (FIRST150)';
        } else {
          alert('FIRST150 requires a minimum subtotal of ₹1499.');
          return;
        }
      } else {
        alert('Invalid coupon code.');
        return;
      }

      sessionStorage.setItem('ilr-coupon', code);
      couponInput.value = code;

      successText.textContent = code + ' applied. You saved ₹' + discountAmount;
      successBanner.style.display = 'flex';
      
      if (discountRow) {
        discountLabel.textContent = label;
        discountVal.textContent = '- ₹' + discountAmount;
        discountRow.style.display = 'flex';
      }

      var newTotal = Math.max(0, originalTotalVal - discountAmount);
      summaryTotal.textContent = formatMoney(newTotal);

      section.querySelectorAll('[data-code]').forEach(function(btn) {
        if (btn.getAttribute('data-code') === code) {
          btn.textContent = 'Applied';
          btn.disabled = true;
        } else {
          btn.textContent = 'Apply';
          btn.disabled = false;
        }
      });
    }

    function removeCoupon() {
      sessionStorage.removeItem('ilr-coupon');
      couponInput.value = '';
      successBanner.style.display = 'none';

      if (discountRow) {
        discountRow.style.display = 'none';
      }

      summaryTotal.textContent = originalTotalText;

      section.querySelectorAll('[data-code]').forEach(function(btn) {
        btn.textContent = 'Apply';
        btn.disabled = false;
      });
    }

    function formatMoney(val) {
      return '₹' + val.toFixed(2).replace(/\.00$/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }

  bind();
})();
